module.exports = __webpack_public_path__ + "static/media/oberflex-ebenedesphilippines-1200x2490.62285b3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-ebenedesphilippines-1200x2490.jpg
// module id = 1002
// module chunks = 37